import { Done } from '@lt/components/icons-react';
import React from 'react';
import { pluralizeOrder } from 'src/utils/pluralizeUtils';
import styled from 'styled-components';
import { orderNumberArray } from '../../../../constants';
import type { OrderAmountFormDesktopProps } from '../../../../types';

const OrdersAmountDesktop = (props: OrderAmountFormDesktopProps) => {
  const { handleOrderNumberClicked, fieldValue } = props;
  return (
    <StyledFieldContainer>
      {orderNumberArray.map((orderNumber) => (
        <StyledOrderNumber
          key={orderNumber}
          onClick={() => handleOrderNumberClicked(orderNumber)}
        >
          <StyledOrderNumberText $bold={fieldValue === orderNumber}>
            {orderNumber} {pluralizeOrder(orderNumber)}
            {fieldValue === orderNumber && <DoneIcon />}
          </StyledOrderNumberText>
        </StyledOrderNumber>
      ))}
    </StyledFieldContainer>
  );
};
const StyledFieldContainer = styled.div`
  position: absolute;
  width: 100%;
  top: 59px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 1px;
  align-self: stretch;
  overflow: scroll;
  width: 143px;
  height: 163px;
  z-index: 50;
  border-radius: 4px;
  background: #e6e9ee;
  box-shadow: 0px 10px 15px 0px rgba(216, 214, 204, 0.9),
    0px 1px 2px 0px rgba(210, 208, 197, 0.9);
  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;
`;
const StyledOrderNumber = styled.div`
  width: 100%;
  background-color: white;
  min-height: 40px;
  padding: 12px 8px;
  z-index: 100;
  cursor: pointer;
  font-size: 14px;
`;
const StyledOrderNumberText = styled.div<{ $bold: boolean }>`
  display: flex;
  justify-content: space-between;
  ${({ $bold }) => $bold && `font-weight: 500;`}
`;
const DoneIcon = styled(Done)`
  width: 16px;
  height: 16px;
  & > path {
    stroke: #17181a;
  }
`;

export default OrdersAmountDesktop;
